import {GET_LOCATIONS} from './types';

export function gotLocations(locations)
{
    return {
        type: GET_LOCATIONS,
        payload: {
            all: locations
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/locations/actions.js